import React, { lazy, Suspense } from "react";
import {
  Switch,
  Route,
  Link
} from "react-router-dom";

import Login from "../pages/Login"
import UserCentre from "../pages/UserCentre"
import UserParcelList from "../pages/UserParcelList"
import UserEditParcel from "../pages/UserEditParcel"
import DataEditor from "../pages/DataEditor"
import CostCalc from "../pages/costcalc"
import Loading from "../components/loading_skeleton";
const AuthRoute = lazy(() => import("../components/privateroute"));

export default function BaseSwitcher() {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <AuthRoute path="/user">
          <UserCentre />
        </AuthRoute>
        <Route path="/parcel/add">
          <UserEditParcel />
        </Route>
        <Route path="/parcel/edit">
          <UserEditParcel />
        </Route>
        <AuthRoute path="/finance">
          <DataEditor model_name='transaction_records' title='财务模块'/>
        </AuthRoute>
        <AuthRoute path="/warehouse">
          <DataEditor model_name='warehouse' title='线路管理'/>
        </AuthRoute>
        <AuthRoute path="/system">
          <DataEditor model_name='system_options' title='系统管理'/>
        </AuthRoute>
        <Route path="/parcel">
          <UserParcelList />
        </Route>
        <Route path="/">
          <CostCalc />
        </Route>
      </Switch>
    </Suspense>
  )
}